var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesBecomeClientHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 24,
    height: 24,
    transform: "translate(441 1143)",
    fill: "#ed8b00",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_590",
    "data-name": "Mask Group 590",
    transform: "translate(-441 -1143)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4857",
    "data-name": "Group 4857",
    transform: "translate(-878.86 1200.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M0,7.08V4.831A5.181,5.181,0,0,1,1.5.947,4.129,4.129,0,0,1,4.307,0a4.115,4.115,0,0,1,2.8.946,5.194,5.194,0,0,1,1.5,3.877V7.085a5.025,5.025,0,0,1-1.419,3.953A4.222,4.222,0,0,1,4.307,12C2.7,11.994,0,11.355,0,7.08ZM1.947,4.885V7.08c0,2.614,1.193,2.967,2.362,2.967S6.666,9.694,6.666,7.08V4.885C6.564,2.3,5.473,1.947,4.307,1.947S2.04,2.3,1.947,4.885Z",
    transform: "translate(1327.555 -57.448)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M.724,10.747A.973.973,0,0,1,.2,9.9V9.881C.158,9.029,0,6.188,0,5.378A4.463,4.463,0,0,1,2.315,1.3,12.974,12.974,0,0,1,8.783,0a12.845,12.845,0,0,1,6.432,1.3,4.468,4.468,0,0,1,2.3,4.077c0,.724-.137,3.088-.219,4.433l-.005.1a.976.976,0,0,1-.971.916h-.062A.974.974,0,0,1,15.348,9.8c0-.027,0-.09.017-.287.051-.849.2-3.429.2-4.134a2.68,2.68,0,0,0-1.554-2.525,11.562,11.562,0,0,0-5.232-.9,11.717,11.717,0,0,0-5.272.9A2.679,2.679,0,0,0,1.947,5.378c0,.5.072,2.081.2,4.343v.065a.973.973,0,0,1-1.422.961Z",
    transform: "translate(1323.102 -44.311)",
    fill: "#ed8b00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesBecomeClientHover);
export default __webpack_public_path__ + "static/media/des-become-client-hover.0e297127d526d2c229f68ad74caf18ea.svg";
export { ForwardRef as ReactComponent };